import { lazy } from "react";
import { Navigate, generatePath, useLocation, useParams } from "react-router-dom";
import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const ArticlesPage = lazy(() =>
  import("@/pages/articles").then((m) => ({ default: m.ArticlesPage }))
);
const ArticleViewPage = lazy(() =>
  import("@/pages/articles/article-detail-page").then((m) => ({
    default: m.ArticleViewPage,
  }))
);

/** `/dashboard/products/...` (o endereço de antes de «produto» passar a «artigo») leva ao endereço novo, com o mesmo id e a mesma query. */
function LegacyArticleRedirect({ to }: { to: string }) {
  const params = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={`${generatePath(to, params)}${search}${hash}`} replace />;
}
const RedirectToArticleList = lazy(() => Promise.resolve({ default: () => <LegacyArticleRedirect to={ROUTES.ARTICLES.LIST} /> }));
const RedirectToArticleDetail = lazy(() => Promise.resolve({ default: () => <LegacyArticleRedirect to={ROUTES.ARTICLES.DETAIL} /> }));
const RedirectToClientArticleList = lazy(() => Promise.resolve({ default: () => <LegacyArticleRedirect to={ROUTES.CLIENTS.ARTICLES.LIST} /> }));
const RedirectToClientArticleDetail = lazy(() => Promise.resolve({ default: () => <LegacyArticleRedirect to={ROUTES.CLIENTS.ARTICLES.DETAIL} /> }));

const ARTICLE_READ = { access: "permission" as const, entity: "articles", action: "READ" };

export const articleRoutes: RouteConfig[] = [
  { path: ROUTES.ARTICLES.LIST, component: ArticlesPage, layout: "dashboard", permissions: ARTICLE_READ },
  { path: ROUTES.ARTICLES.DETAIL, component: ArticleViewPage, layout: "dashboard", permissions: ARTICLE_READ },
  { path: ROUTES.ARTICLES.LEGACY_LIST, component: RedirectToArticleList, layout: "dashboard", permissions: ARTICLE_READ },
  { path: ROUTES.ARTICLES.LEGACY_DETAIL, component: RedirectToArticleDetail, layout: "dashboard", permissions: ARTICLE_READ },
  { path: ROUTES.ARTICLES.LEGACY_CLIENT_LIST, component: RedirectToClientArticleList, layout: "dashboard", permissions: ARTICLE_READ },
  { path: ROUTES.ARTICLES.LEGACY_CLIENT_DETAIL, component: RedirectToClientArticleDetail, layout: "dashboard", permissions: ARTICLE_READ },
];
